module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalImportarPlantillaEmpleado) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-image', {
    attrs: {
      "name": "name",
      "folder": "empleados",
      "is-saved": _vm.isSavedAdjunto
    },
    on: {
      "close": _vm.closeAdjuntar,
      "save": _vm.procesoPlantilla
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Plantilla de Empleados")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la plantilla de empleados")])])], 1) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno position-relative"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestión de empleados")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarFiltros) ? _c('div', {
    key: "input-filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado,
      "empleadosInactivos": 'all'
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)])]) : _vm._e(), _c('div', {
    key: "boton-filtro",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.nuevoEmpleado
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-fw fa-lg"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openModalImportarEmpleados
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Excel")])]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.descargarPlantillaEmpleados
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw fa-lg"
  })]), _c('span', [_vm._v("Descargar plantilla")])])])])], 1), _c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }],
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Ingreso")]), _c('th', [_vm._v("DNI")]), _c('th', [_vm._v("Jefe")]), _c('th')]), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "table-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: ("index_" + (index + 1)),
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('span', [_vm._v(_vm._s(o.nombre))]), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.email))]), _c('br'), (!o.activo && o.fechaInactivo) ? _c('span', {
      staticClass: "name seen has-text-bold"
    }, [_vm._v("Inactivo desde " + _vm._s(o.fechaInactivo))]) : _vm._e()]), _c('td', [_c('div', {
      staticClass: "wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaIngreso))]), (!o.contratoIndeterminado) ? [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]] : _vm._e()], 2)]), _c('td', [_vm._v(_vm._s(o.dni))]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.emailJefe))])]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.activo) ? _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Ver")])]), (o.activo) ? _c('button', {
      staticClass: "button is-small margin-left-5 is-danger",
      on: {
        "click": function($event) {
          return _vm.openModalDarBajaEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-down"
    })]), _c('span', [_vm._v("Desactivar")])]) : _vm._e()])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left",
      class: {
        'is-close': !o.activo
      }
    }, [_c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dni))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(o.email))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), (!o.contratoIndeterminado) ? _c('div', [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]], 2) : _vm._e(), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email jefe: ")]), _c('span', [_vm._v(_vm._s(o.emailJefe))])])] : _vm._e(), (!o.activo && o.fechaInactivo) ? _c('div', {
      staticClass: "mt-5"
    }, [_c('span', {
      staticClass: "name seen has-text-bold"
    }, [_vm._v("Inactivo desde " + _vm._s(o.fechaInactivo))])]) : _vm._e(), _c('div', {
      staticClass: "contenedor-acciones mt-10"
    }, [(o.activo) ? _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Ver")])]), (o.activo) ? _c('button', {
      staticClass: "button is-small margin-left-5 is-danger",
      on: {
        "click": function($event) {
          return _vm.openModalDarBajaEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-down"
    })]), _c('span', [_vm._v("Desactivar")])]) : _vm._e()])], 2)
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])])])]), (_vm.mostrarModalDarDeBajaEmpleadoEmpleado) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarModalDarDeBajaEmpleadoEmpleado, 'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalDarBajaEmpleado),
      expression: "closeModalDarBajaEmpleado"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Dar de baja empleado")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalDarBajaEmpleado
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("¿ Esta seguro de dar baja al empleado")]), _c('strong', [_vm._v(" " + _vm._s(_vm.codigoEmpleado) + " - " + _vm._s(_vm.nombreEmpleado))]), _c('span', [_vm._v("?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.desactivarEmpleado()
      }
    }
  }, [_c('span', [_vm._v("Dar de baja")])]), _c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalDarBajaEmpleado
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarObservaciones) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarObservaciones
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalObservaciones),
      expression: "closeModalObservaciones"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Observaciones encontradas")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalObservaciones
    }
  })])])]), _c('div', {
    staticClass: "card-content card-content-observaciones-max-height"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, _vm._l((_vm.observaciones), function(o) {
    return (_vm.observaciones.length > 0) ? _c('div', [_c('strong', [_vm._v(_vm._s(o))])]) : _vm._e()
  }), 0)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalObservaciones
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarProcesandoPlantilla) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarProcesandoPlantilla
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Procesando")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', [_vm._v(_vm._s(_vm.mensajeProcesoPlantilla))])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    class: {
      'is-loading': _vm.mostrarProcesandoPlantilla
    },
    attrs: {
      "disabled": _vm.mostrarProcesandoPlantilla
    }
  }, [_c('span')])])])])]) : _vm._e(), (_vm.mostrarModalEditarEmpleado) ? _c('editar-empleado', {
    attrs: {
      "codigoEmpleado": _vm.codigoEmpleado
    },
    on: {
      "close": _vm.closeModalEditarEmpleado
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eed6eb4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Gestion_Empleado.vue
// module id = 819
// module chunks = 0